import type { ValueOf } from 'type-fest';

export const colors = {
  dark: 'dark',
  light: 'light',
} as const;

export const brands = {
  sats: 'sats',
  elixia: 'elixia',
} as const;

export const sizes = {
  large: 'large',
  small: 'small',
} as const;

export type Logo = {
  brand?: ValueOf<typeof brands>;
  color?: ValueOf<typeof colors>;
  href?: string;
  label?: string;
  size?: ValueOf<typeof sizes>;
  specialLogo?: boolean;
};
